// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-card-link {
  display: block;
  height: 100%;
  color: inherit;
  text-decoration: none;
}

.app-card-link:hover {
  color: inherit;
}

.app-card {
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-sm);
  transition: var(--transition);
  overflow: hidden;
  height: 100%;
  cursor: pointer;
  background: var(--color-bg-white);
  border: 1px solid #f0f0f0;
}

.game-card-hover:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-4px);
  border-color: rgba(108, 92, 231, 0.2);
}

.app-card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

.app-image-section {
  position: relative;
  overflow: hidden;
}

.app-image {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  transition: var(--transition);
}

.game-card-hover:hover .app-image {
  transform: scale(1.05);
}

.app-tags {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  gap: 4px;
}

.tag-new {
  background: var(--color-secondary) !important;
  color: white !important;
  border: none !important;
  font-size: 10px !important;
  padding: 2px 6px !important;
  border-radius: 4px !important;
  font-weight: 500;
}

.tag-hot {
  background: var(--color-accent) !important;
  color: white !important;
  border: none !important;
  font-size: 10px !important;
  padding: 2px 6px !important;
  border-radius: 4px !important;
  font-weight: 500;
}

.app-info-section {
  padding: 12px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.app-title {
  margin: 0 0 8px 0 !important;
  font-weight: 500;
  color: var(--color-text);
  font-size: 14px;
  line-height: 1.3;
}

.app-rating {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  min-width: 0;
}

.rating-stars {
  min-width: 0;
  white-space: nowrap;
}

.rating-stars .ant-rate {
  color: #faad14 !important;
  font-size: 12px !important;
  line-height: 1 !important;
}

.rating-score {
  font-size: 11px;
  color: var(--color-text-secondary);
  font-weight: 500;
  margin-left: 4px;
}

@media (max-width: 768px) {
  .app-card {
    border-radius: 12px;
  }

  .app-info-section {
    padding: 8px;
  }

  .app-title {
    font-size: 13px;
  }

  .rating-stars .ant-rate {
    font-size: 10px !important;
    line-height: 1 !important; /* 减少行高防止折行 */
  }

  .rating-stars {
    white-space: nowrap; /* 确保星星不换行 */
  }

  .rating-score {
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .app-title {
    font-size: 12px;
  }

  .rating-stars .ant-rate {
    font-size: 9px !important;
    line-height: 1 !important;
  }

  .rating-stars {
    white-space: nowrap;
  }

  .rating-score {
    font-size: 9px;
  }

  .app-tags {
    top: 6px;
    left: 6px;
  }

  .tag-new,
  .tag-hot {
    font-size: 9px !important;
    padding: 1px 4px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AppCard/AppCard.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6CAA6C;EAC7C,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB,EAAE,aAAa;EAC1C;;EAEA;IACE,mBAAmB,EAAE,YAAY;EACnC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;;EAEA;;IAEE,yBAAyB;IACzB,2BAA2B;EAC7B;AACF","sourcesContent":[".app-card-link {\n  display: block;\n  height: 100%;\n  color: inherit;\n  text-decoration: none;\n}\n\n.app-card-link:hover {\n  color: inherit;\n}\n\n.app-card {\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-sm);\n  transition: var(--transition);\n  overflow: hidden;\n  height: 100%;\n  cursor: pointer;\n  background: var(--color-bg-white);\n  border: 1px solid #f0f0f0;\n}\n\n.game-card-hover:hover {\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-4px);\n  border-color: rgba(108, 92, 231, 0.2);\n}\n\n.app-card-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n}\n\n.app-image-section {\n  position: relative;\n  overflow: hidden;\n}\n\n.app-image {\n  width: 100%;\n  aspect-ratio: 1;\n  object-fit: cover;\n  transition: var(--transition);\n}\n\n.game-card-hover:hover .app-image {\n  transform: scale(1.05);\n}\n\n.app-tags {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  display: flex;\n  gap: 4px;\n}\n\n.tag-new {\n  background: var(--color-secondary) !important;\n  color: white !important;\n  border: none !important;\n  font-size: 10px !important;\n  padding: 2px 6px !important;\n  border-radius: 4px !important;\n  font-weight: 500;\n}\n\n.tag-hot {\n  background: var(--color-accent) !important;\n  color: white !important;\n  border: none !important;\n  font-size: 10px !important;\n  padding: 2px 6px !important;\n  border-radius: 4px !important;\n  font-weight: 500;\n}\n\n.app-info-section {\n  padding: 12px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.app-title {\n  margin: 0 0 8px 0 !important;\n  font-weight: 500;\n  color: var(--color-text);\n  font-size: 14px;\n  line-height: 1.3;\n}\n\n.app-rating {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: auto;\n  min-width: 0;\n}\n\n.rating-stars {\n  min-width: 0;\n  white-space: nowrap;\n}\n\n.rating-stars .ant-rate {\n  color: #faad14 !important;\n  font-size: 12px !important;\n  line-height: 1 !important;\n}\n\n.rating-score {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n  margin-left: 4px;\n}\n\n@media (max-width: 768px) {\n  .app-card {\n    border-radius: 12px;\n  }\n\n  .app-info-section {\n    padding: 8px;\n  }\n\n  .app-title {\n    font-size: 13px;\n  }\n\n  .rating-stars .ant-rate {\n    font-size: 10px !important;\n    line-height: 1 !important; /* 减少行高防止折行 */\n  }\n\n  .rating-stars {\n    white-space: nowrap; /* 确保星星不换行 */\n  }\n\n  .rating-score {\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .app-title {\n    font-size: 12px;\n  }\n\n  .rating-stars .ant-rate {\n    font-size: 9px !important;\n    line-height: 1 !important;\n  }\n\n  .rating-stars {\n    white-space: nowrap;\n  }\n\n  .rating-score {\n    font-size: 9px;\n  }\n\n  .app-tags {\n    top: 6px;\n    left: 6px;\n  }\n\n  .tag-new,\n  .tag-hot {\n    font-size: 9px !important;\n    padding: 1px 4px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
